module.exports = __webpack_public_path__ + "static/media/ope_katja_902x1353.885b5821.jpg";